<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { showModal } from '@/Utils/modalBus'
import EmptyState from '@/components/ui/EmptyState.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconPlaylist from '@/components/icon/IconPlaylist.vue'
import IconPlus from '@/components/icon/IconPlus.vue'
import IconPlay from '@/components/icon/IconPlay.vue'
import IconBookOpen from '@/components/icon/IconBookOpen.vue'
import DemoVideoModal from '@/components/modals/DemoVideoModal.vue'

const emit = defineEmits({
  'showAddPlaylistModal': () => true
})

const store = useStore()

const hasLiveSubscription = computed(() => store.getters['User/hasLiveSubscription'])

const showDemoModal = () => showModal('modal-demo-video-empty')
</script>

<template>
  <EmptyState title="Create your first playlist"
    subtitle="Line up your live streams and videos into one shareable playlist for your viewers.">
    <template #icon>
      <icon-base width="28" height="28">
        <icon-playlist />
      </icon-base>
    </template>
    <template #actions>
      <FormButton type="secondary" class="w-64 justify-center" target="_blank"
        href="https://docs.castr.com/en/articles/8181381-create-playlist-for-your-content">
        <icon-base class="mr-2">
          <icon-book-open />
        </icon-base>
        How playlists work
      </FormButton>
      <FormButton type="secondary" class="w-64 justify-center" @click="showDemoModal">
        <icon-base class="mr-2">
          <icon-play />
        </icon-base>
        Watch a demo
      </FormButton>
      <FormButton v-if="hasLiveSubscription" class="w-64 justify-center" @click="emit('showAddPlaylistModal')">
        <icon-base class="mr-2">
          <icon-plus />
        </icon-base>
        New playlist
      </FormButton>
      <FormButton v-else class="w-64 justify-center" to="/subscribe">
        Upgrade
      </FormButton>
    </template>
    <DemoVideoModal modalId="modal-demo-video-empty" videoid="tDgMUJ40LkS3jrnJeMTQc" />
  </EmptyState>
</template>
